import { ChangeDetectorRef, Component, ComponentFactoryResolver, NgZone, OnInit, ViewContainerRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TalentInsightsFreeTrialFormComponent } from '../talent-insights-free-trial-form/talent-insights-free-trial-form.component';
import { TalentInsightsFreeTrialModalComponent } from '../talent-insights-free-trial-modal/talent-insights-free-trial-modal.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FreemiumAPIService, FreeTrialRequest } from '../freemium-api.service';
import { FreemiumService } from '../freemium.service';
import { GaEventsService } from 'src/app/_services/ga-events.service';
import { UserprofileComponent } from '../userprofile/userprofile.component';
import { ViewportScroller } from '@angular/common';

@Component({
    selector: 'app-ai-resume-screener',
    templateUrl: './ai-resume-screener.component.html',
    styleUrls: ['./ai-resume-screener.component.scss'],
    standalone: false
})
export class AiResumeScreenerComponent implements OnInit {

  showAILoader: boolean = false;
  resumeAIPayload: any;
  domainList:any[] =  FreemiumService.invalid_workemail_domain_list;
  // freeTrialForm = new FormGroup({
  //   workEmail: new FormControl(null, Validators.compose([Validators.required, Validators.pattern('^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$')])),
  // })
  constructor(public modalService: NgbModal,private freemiumApiService: FreemiumAPIService,private gaService: GaEventsService,
     private cdr: ChangeDetectorRef,
  private ngZone: NgZone,
  ) { }

  ngOnInit() {
    //   this.freeTrialForm.get('workEmail').valueChanges.subscribe(res=>{
    //   if(res) {
    //     const invaliEmail = this.domainList.filter(x=>res.includes(x));
    //     if(invaliEmail.length > 0) {
    //       this.freeTrialForm.get('workEmail').setErrors({'invaliDomain': true});
    //     } else {
    //       this.freeTrialForm.get('workEmail').setErrors(null, {emitEvent: false});
    //     }
    //   }
    // })
  }

  getAICandidate(event){
    if(event.status == "fetch"){
      this.resumeAIPayload = event.data;

      this.showAILoader = true;
    this.cdr.detectChanges(); // ensure DOM update

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const userSection = document.querySelector<HTMLElement>("#user");
        if (userSection) {
          userSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // give Angular time to render
    });
  }
}

redirectDemo(type) {
  if(type == 'one') {
    this.gaService.trackButtonClick('Book_a_Demo_1');
   } else if(type == 'two') {
    this.gaService.trackButtonClick('Book_a_Demo_2');
   } else if(type == 'three') {
        this.gaService.trackButtonClick('Book_a_Demo_3');

   }
     const url = "https://calendly.com/customer-success-webbtree/30min"
     window.open(url, "_blank");

}

  tryForFree(){
    // const modalRef = this.modalService.open(TalentInsightsFreeTrialModalComponent, { windowClass: 'day-trail-model', centered: true });
    // console.log(this.freeTrialForm, 'form')

  }
  // calendlyModal(){
  //         window.parent.postMessage({ action: "BookDemo"}, "*");

    // <!-- Calendly badge widget begin -->
// <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet">
// <script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script>


// <script type="text/javascript">window.onload =


// function() { Calendly.initBadgeWidget({ url: 'https://calendly.com/customer-success-webbtree?hide_gdpr_banner=1', text: 'Book a Demo', color: '#0069FF', textColor: '#FFFFFF', branding: true }); }</script>
// <!-- Calendly badge widget end -->
  // }


}
